// extracted by mini-css-extract-plugin
module.exports = {"content":"picto_content__mAQu2","iconWrapper":"picto_iconWrapper__S9ELc","picto":"picto_picto__LC6s5","disableBorder":"picto_disableBorder__CCOzh"};